/* ==========================================================================
   ASIAMARCHÉ — FOOTER
   Fichier : assets/footer-asiamarche.js
   Accordéons mobile + réinit dans l'éditeur de thème + lien cookies.
   ========================================================================== */
(function () {
  'use strict';

  var MQ = '(max-width: 760px)';

  function initFooter(root) {
    if (!root || root.dataset.amReady === 'true') return;

    var mq = window.matchMedia(MQ);

    root.querySelectorAll('.am-col').forEach(function (col) {
      var title = col.querySelector('.am-col__title');
      var list = col.querySelector('.am-col__list');
      if (!title || !list) return;

      if (!list.id) {
        list.id = 'am-col-' + Math.random().toString(36).slice(2, 8);
      }

      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-controls', list.id);

      // Ouverte par défaut sur mobile si la case est cochée dans l'éditeur
      var openByDefault = col.dataset.openMobile === 'true';
      if (openByDefault) col.classList.add('is-open');

      function sync() {
        if (mq.matches) {
          title.setAttribute('aria-expanded', String(col.classList.contains('is-open')));
        } else {
          title.removeAttribute('aria-expanded');
        }
      }

      function toggle() {
        if (!mq.matches) return;
        col.classList.toggle('is-open');
        sync();
      }

      title.addEventListener('click', toggle);
      title.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          toggle();
        }
      });

      if (mq.addEventListener) {
        mq.addEventListener('change', function () {
          if (!mq.matches) {
            col.classList.toggle('is-open', openByDefault);
          }
          sync();
        });
      }

      sync();
    });

    // Lien « Gérer mes cookies » : ouvre la bannière de consentement Shopify
    root.querySelectorAll('[data-am-cookie]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var api = window.Shopify && window.Shopify.customerPrivacy;
        if (api && typeof api.showPreferences === 'function') {
          api.showPreferences();
        } else if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          window.privacyBanner.showPreferences();
        } else {
          window.location.href = '/policies/privacy-policy';
        }
      });
    });

    root.dataset.amReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('.am-footer').forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // L'éditeur de thème réinjecte le HTML de la section : il faut réinitialiser
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.am-footer');
    if (root) {
      delete root.dataset.amReady;
      initFooter(root);
    }
  });
})();